import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router-dom/Link';

NotFound.propTypes = {
    isNoAccesss: PropTypes.bool
};

NotFound.defaultProps = {
    isNoAccesss: false
};

export default function NotFound(props) {
    return (
        <div className='main-screen'>
            <div className='container not-found'>
                <h2>Oops! {props.isNoAccesss ? 'Access to this page is not allowed.' : 'Nothing found!'}</h2>

                <p>
                    <Link to='/'>Go to the homepage</Link>
                </p>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js